import React from 'react';
import ReactDOM from 'react-dom/client';
import Process360Diagnostic from './Process360Diagnostic';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Process360Diagnostic />
  </React.StrictMode>
);
